module.exports = __webpack_public_path__ + "img/m2.a0b54039.png";